export type ResultTuple<Data, Err> = [Data, null] | [null, Err];

type TryCatchReturn<TInput, E> =
	TInput extends Promise<infer TData>
		? Promise<ResultTuple<TData, E>>
		: TInput extends () => infer TData
			? ResultTuple<TData, E>
			: never;

export function tryCatch<TInput, E = Error>(
	action: TInput
): TryCatchReturn<TInput, E> {
	if (action instanceof Promise) {
		return action
			.then((data: unknown) => [data, null] as const)
			.catch(
				(error: unknown) => [null, error as E] as const
			) as unknown as TryCatchReturn<TInput, E>;
	}

	if (typeof action === 'function') {
		try {
			const data = (action as () => unknown)();
			return [data, null] as unknown as TryCatchReturn<TInput, E>;
		} catch (error) {
			return [null, error as E] as unknown as TryCatchReturn<TInput, E>;
		}
	}

	throw new Error('Argument must be a Promise or a Function');
}

export function noOp() {
	/* noOp */
}

export async function forceDownload(
	url: string,
	fileName: string
): Promise<void> {
	try {
		const response = await fetch(url);
		const blob = await response.blob();
		const blobUrl = globalThis.URL.createObjectURL(blob);

		const link = document.createElement('a');
		link.href = blobUrl;
		link.download = fileName;
		document.body.appendChild(link);
		link.click();

		link.remove();
		globalThis.URL.revokeObjectURL(blobUrl);
	} catch {
		/* empty */
	}
}
